const tr = {
    bottomNavbar : {
        listTitle : 'Listem',
        accountTitle : 'Hesabım'
    },
    signup : {
        signupTitle : 'Hesabım',
        emailPlaceholder: 'E-posta',
        emailError: 'Geçerli e-posta adresiniz giriniz ',
        emailRequired: 'E-posta alanı zorunludur',
        passwordPlaceholder: 'Şifre',
        passwordError: 'Şifre en az 8 karakter olmalı',
        passwordRequired: 'Şifre alanı zorunludur',
        signupBtn: 'Kayıt Ol',
    },
    account: {
        accountTitle: 'Hesabım',
        accountEmail : 'E-posta',
        accountPassword : 'Şifre',
        accountLocale : 'Dil',
        accountLogout: 'Çıkış Yap'
    },
    basket:{
        addBasket: "SEPETE EKLE",
        removeBasket : "SEPETTEN SİL",
        totalOfProducts : "Ürünlerin Toplamı",
        total : "Toplam",
        taxCargo : "Vergiler + Kargo",
        generalTotal : "Genel Toplam",
        emptyBasket:"Sepetiniz boş !",

    },
    messages: {
        signupSuccess: 'Kayıt başarılı.',
        signupError : 'Bu kullanıcı zaten kayıtlı !',
    },
    locale: {
        tr:"Türkçe",
        en:"English"
    }
};

export default tr